module.exports = __webpack_public_path__ + "img/appAsset--users-ax.41caa89c.svg";